import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { CompanyInterceptor } from 'src/app/custom/interceptors/company.interceptor';
import { UserData } from 'src/app/data/user.data';

/* Add domain specific singleton services here */
export function services() {
  return [];
}
export function interceptors() {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompanyInterceptor,
      multi: true,
      deps: [UserData],
    },
  ];
}
export function gurads() {
  return [];
}

@NgModule()
export class CustomModule {
  constructor() {
    const parentModule = inject(CustomModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CustomModule is already loaded. Import it in the AppModule only');
    }
  }
  public static forRoot(): ModuleWithProviders<CustomModule> {
    return {
      ngModule: CustomModule,
      providers: [...services(), ...interceptors(), ...gurads()],
    };
  }
}
